import { extendTheme } from "@chakra-ui/react";

const primaryColor = "#000000BF";
const secondaryColor = "#000000A6";
const mccBlue = "#288af3";

export const mccTheme = extendTheme({
  breakpoints: {
    base: "0px",
    sm: "1000px",
    md: "1200px",
    lg: "1400px",
    xl: "1600px",
    "2xl": "1800px",
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 400,
      },
      variants: {
        solid: {
          bg: "#fafafa",
          border: "1px solid lightgrey",
          _focus: {
            boxShadow: 'none', // Disable the default focus ring
            border: `2px solid ${mccBlue}`,
          },
        },
      },
    },
    Select: {
      baseStyle: {
        field: {
          bg: "#fafafa",
          border: "1px solid lightgrey",
          _focus: {
            border: `2px solid ${mccBlue}`,
          }
        },
      },
    },
    Input: {
      baseStyle: {
        field: {
          bg: "#fafafa",
          border: "1px solid lightgrey",
          _focus: {
            border: `2px solid ${mccBlue}`,
          }
        },
      },
      variants: {
        outline: {
          addon: {
            bg: "#F1F1F1",
            borderColor: "lightgrey",
          },
        },
      },
    },
  },
  textStyles: {
    h2: {
      color: primaryColor,
      textAlign: "left",
      "font-size": ["28px", "38px"],
      fontFamily: `'Poppins', sans-serif`,
      fontWeight: 500,
    },
    h3: {
      color: primaryColor,
      textAlign: "left",
      "font-size": ["22px", "28px"],
      fontFamily: `'Poppins', sans-serif`,
      fontWeight: 500,
    },
    h4: {
      color: primaryColor,
      textAlign: "left",
      "font-size": ["20px", "22px"],
      fontFamily: `'Poppins', sans-serif`,
      fontWeight: 500,
    },
    "body-label": {
      color: secondaryColor,
      textAlign: "left",
      "font-size": "14px",
      fontFamily: `'Lexend', sans-serif`,
      fontWeight: 400,
    },
    "body-regular": {
      color: secondaryColor,
      textAlign: "left",
      "font-size": "16px",
      fontFamily: `'Lexend', sans-serif`,
      fontWeight: "400",
    },
    "button-regular": {
      color: secondaryColor,
      textAlign: "left",
      "font-size": "18px",
      fontFamily: `'Lexend', sans-serif`,
      fontWeight: 500,
    },
  },
});